<template>
  <div>
    <!-- Toast de alerta -->
    <ToastAlert
      :is-active="toastAlert"
      :type="typeMsg"
      :message="msg"
      :title="tittle"
      @close="closeToast"
    />
    <div class="flex max-w-[1440px] mx-auto h-full font-poppins bg-white">
      <!-- Panel izquierdo -->
      <div class="w-full sm:w-1/2 flex flex-col bg-white min-h-screen">
        <!-- Encabezado -->
        <HeaderComponent class="md:mb-6 mb-4" />

        <!-- Contenido -->
        <div class="mb-4 mx-auto px-5 md:p-0 md:ml-[80px] md:mx-0 w-11/12 md:w-3/4 max-w-[384px] bg-white">
          <!-- Barra de progreso -->
          <div class="flex justify-between mb-0">
            <span></span>
            <span class="text-sm font-medium text-custom_gray">{{ currentStep + 1 }}/4</span>
          </div>
          <div class="md:mb-6 mb-3 w-full bg-[#D9D9D9] rounded-full h-2.5">
            <div class="bg-tuin-100 h-2.5 rounded-full" :style="{ width: progressPercentage + '%' }"></div>
          </div>
          <!-- Título y descripción -->
          <h5 class="lg:text-32 text-lg font-medium text-custom_black">
            Nos gustaría conocerte
          </h5>
          <p class="text-custom_black2 font-normal text-sm lg:text-base not-italic">
            Ayúdanos a completar tus datos
          </p>

          <!-- Nombre input -->
          <div class="mt-6">
            <label for="name" class="block mb-2 text-sm font-medium text-custom_gray">Nombre(s)*</label>
            <input 
              type="text" 
              v-model="userName" 
              name="name" 
              id="name" 
              :class="{
                'bg-white border border-gray-300 text-custom_gray text-sm rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5': !errors.name,
                'border border-red-500 bg-red-50 text-custom_gray text-sm rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5': errors.name
              }" 
              placeholder="Ingresa tu nombre" 
              required 
              @blur="validateName"
            />
            <p v-if="errors.name" class="mt-1 text-sm font-medium text-red-600">{{ errors.name }}</p>
          </div>

          <!-- Apellido Paterno -->
          <div class="mt-4">
            <label for="lastName" class="block mb-2 text-sm font-medium text-custom_gray">Apellido Paterno*</label>
            <input 
              type="text" 
              v-model="lastName" 
              name="lastName" 
              id="lastName" 
              :class="{
                'bg-white border border-gray-300 text-custom_gray text-sm rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5': !errors.lastName,
                'border border-red-500 bg-red-50 text-custom_gray text-sm rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5': errors.lastName
              }" 
              placeholder="Ingresa tu apellido paterno" 
              required 
              @blur="validateLastName"
            />
            <p v-if="errors.lastName" class="mt-1 text-sm font-medium text-red-600">{{ errors.lastName }}</p>
          </div>

          <!-- Apellido Materno -->
          <div class="mt-4">
            <label for="motherLastName" class="block mb-2 text-sm font-medium text-custom_gray">Apellido Materno*</label>
            <input 
              type="text" 
              v-model="motherLastName" 
              name="motherLastName" 
              id="motherLastName" 
              :class="{
                'bg-white border border-gray-300 text-custom_gray text-sm rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5': !errors.motherLastName,
                'border border-red-500 bg-red-50 text-custom_gray text-sm rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5': errors.motherLastName
              }" 
              placeholder="Ingresa tu apellido materno" 
              required 
              @blur="validateMotherLastName"
            />
            <p v-if="errors.motherLastName" class="mt-1 text-sm font-medium text-red-600">{{ errors.motherLastName }}</p>
          </div>

          <!-- Número de Celular -->
          <div class="mt-4">
            <label for="phone" class="block mb-2 text-sm font-medium text-custom_gray">Número de Celular*</label>
            
            <div class="custom-select-container">
              <div class="selected-option" @click.stop="toggleDropdown">
                <div v-if="selectedCountry" class="country-item">
                  <img 
                    v-if="getSelectedCountry && getSelectedCountry.flag" 
                    :src="getSelectedCountry.flag" 
                    :alt="`Bandera de ${getSelectedCountry.name}`" 
                    class="flag-img"
                  />
                  <span>{{ getSelectedCountry ? getSelectedCountry.name : '' }} ({{ selectedCountry }})</span>
                </div>
                <div v-else class="placeholder">Selecciona un país</div>
                <div class="arrow-down"></div>
              </div>

              <!-- Dropdown options -->
              <div class="dropdown-menu" v-if="isDropdownOpen">
                <div 
                  v-for="country in filteredCountries" 
                  :key="country.dial_code"
                  class="country-option"
                  @click="selectCountry(country.dial_code)"
                >
                  <img 
                    v-if="country.flag" 
                    :src="country.flag" 
                    :alt="`Bandera de ${country.name}`" 
                    class="flag-img"
                  />
                  <span>{{ country.name }} ({{ country.dial_code }})</span>
                </div>
              </div>
            </div>

            <!-- Número de celular input -->
            <div class="phone-input mt-2">
              <input 
                type="text" 
                v-model="phoneNumber" 
                id="phone-input" 
                :class="{
                  'bg-white border border-gray-300 text-custom_gray text-sm rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5': !errors.phoneNumber,
                  'border border-red-500 bg-red-50 text-custom_gray text-sm rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5': errors.phoneNumber
                }" 
                placeholder="Ingresa tu número de celular" 
                required 
                @input="onlyNumbers" 
                @blur="validatePhoneNumber"
              />
              <p v-if="errors.phoneNumber" class="mt-1 text-sm font-medium text-red-600">{{ errors.phoneNumber }}</p>
            </div>
            <p v-if="error" class="error-message text-red-500 text-sm mt-1">{{ error }}</p>
          </div>
            
          <div class="mt-6">
            <button
              type="submit"
              @click="sendOTP"
              class="w-full bg-tuin-100 text-white font-semibold py-2.5 px-4 rounded-lg hover:bg-tuin_hover transition disabled:bg-tuin-100 disabled:cursor-not-allowed"
              :disabled="isSubmitting"
            >
              <!--<span v-if="isSubmitting">Guardando...</span>-->
              <span>Continuar</span>
            </button>
          </div>
        </div>
      </div>
      <!-- Panel derecho con imagen -->
      <div class="hidden w-1/2 sm:flex items-center justify-center">
        <div>
          <img
            src="@/assets/imgs/undraw_small-town_76a2.svg"
            alt="Tuin hora de hacer magia"
            class="max-h-[353px] max-w-[717px]"
          >
        </div>
      </div>
    </div>
  </div>
  
</template>

<script setup>
import HeaderComponent from '@/components/login/HeaderComponent.vue'
import ToastAlert from '@/commond/ToastAlert.vue'
import { ref, computed, onMounted} from 'vue'
import { useStore } from "vuex";
import axios from "axios";
import { useRouter } from "vue-router";

const router = useRouter();
const store = useStore();
const session = computed(() => store.getters.getUserSession);

// Form fields
const currentStep = ref(1);
const userName = ref('');
const lastName = ref('');
const motherLastName = ref('');
const phoneNumber = ref('');
const userProfile = ref(null);

// Estado de errores
const errors = ref({
  name: '',
  lastName: '',
  motherLastName: '',
  phoneNumber: ''
});

// Country code selector
const countryCodes = ref([]);
const selectedCountry = ref("");
const isDropdownOpen = ref(false);
const error = ref("");
const isSubmitting = ref(false);
const validationErrors = ref({});

// Default rol ID - adjust as needed
const defaultRolId = ref(2); // Assuming 2 is for advisor role

// Progress calculation
const progressPercentage = computed(() => ((currentStep.value + 1) / 4) * 100);

// Estado para alertas
const toastAlert = ref(false)
const typeMsg = ref('')
const msg = ref('')
const tittle = ref('')

// Funciones de validación
function validateName() {
  errors.value.name = '';
  
  if (!userName.value) {
    errors.value.name = 'Campo obligatorio';
    return false;
  }
  
  return true;
}

function validateLastName() {
  errors.value.lastName = '';
  
  if (!lastName.value) {
    errors.value.lastName = 'Campo obligatorio';
    return false;
  }
  
  return true;
}

function validateMotherLastName() {
  errors.value.motherLastName = '';
  
  if (!motherLastName.value) {
    errors.value.motherLastName = 'Campo obligatorio';
    return false;
  }
  
  return true;
}

function validatePhoneNumber() {
  errors.value.phoneNumber = '';
  
  if (!phoneNumber.value) {
    errors.value.phoneNumber = 'Campo obligatorio';
    return false;
  }

  // Validar que el número tenga exactamente 10 dígitos
  const phoneRegex = /^\d{10}$/;
  if (!phoneRegex.test(phoneNumber.value)) {
    errors.value.phoneNumber = 'El número debe tener exactamente 10 dígitos';
    return false;
  }

  return true;
}

function validateForm() {
  // Ejecutar todas las validaciones para asegurar que se muestren todos los errores
  const isNameValid = validateName();
  const isLastNameValid = validateLastName();
  const isMotherLastNameValid = validateMotherLastName();
  const isPhoneNumberValid = validatePhoneNumber();
  
  // Validar que se haya seleccionado un país
  if (!selectedCountry.value) {
    error.value = 'Debes seleccionar un país';
    return false;
  }
  
  return isNameValid && isLastNameValid && isMotherLastNameValid && isPhoneNumberValid && selectedCountry.value !== '';
}

// Computed property para obtener el país seleccionado completo
const getSelectedCountry = computed(() => {
  return countryCodes.value.find(country => country.dial_code === selectedCountry.value);
});

// Función para cerrar el dropdown cuando se hace clic fuera
const closeDropdown = (e) => {
  const container = document.querySelector('.custom-select-container');
  if (container && !container.contains(e.target)) {
    isDropdownOpen.value = false;
  }
};

onMounted(() => {
  document.addEventListener('click', closeDropdown);
  getProfile(); // Cargar datos del perfil al montar el componente
  loadCountryCodes();
});

// Obtener el perfil del usuario y llenar los campos automáticamente
const getProfile = async () => {
  if (!session.value || !session.value.token_api || !session.value.id) {
    error.value = "No se encontró la sesión del usuario. Vuelve a iniciar sesión.";
    return;
  }
  
  try {
    let options = {
      headers: {
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };
    
    const response = await axios.get(
      `${process.env.VUE_APP_API_BASE_URL}/broker/profile/${session.value.id}`,
      options
    );
    
    if (response.status === 200) {
      // Guardar datos del perfil
      userProfile.value = response.data.resp;
      
      // Llenar los campos del formulario con los datos del perfil
      if (userProfile.value) {
        // Llenar nombre y apellidos si existen
        if (userProfile.value.info) {
          userName.value = userProfile.value.info.name || '';
          lastName.value = userProfile.value.info.last_name || '';
          motherLastName.value = userProfile.value.info.last_second_name || '';
        }
        
        // Establecer el código de país y número de teléfono si existen
        if (userProfile.value.info && userProfile.value.info.phones && userProfile.value.info.phones.length > 0) {
          // Si hay información de teléfono con código de país
          const phoneInfo = userProfile.value.info.phones[0];
          selectedCountry.value = phoneInfo.country_code;
          phoneNumber.value = phoneInfo.phone_number;
        } else if (userProfile.value.info && userProfile.value.info.phone) {
          // Si solo hay número de teléfono sin código
          phoneNumber.value = userProfile.value.info.phone;
        }
        
        // Usar el phone_country_code si está disponible y selectedCountry aún no se ha establecido
        if (!selectedCountry.value && userProfile.value.phone_country_code) {
          selectedCountry.value = userProfile.value.phone_country_code;
        }
      }
    }
  } catch (err) {
    console.error("Error al obtener datos del perfil:", err);
    if (err.response && err.response.status === 401) {
      store.dispatch("clearUserSession");
      router.push({ name: 'login' });
    } else {
      error.value = "Error al cargar los datos del perfil. Inténtalo nuevamente.";
    }
  }
};


// Toggle dropdown
const toggleDropdown = () => {
  isDropdownOpen.value = !isDropdownOpen.value;
};

// Select country
const selectCountry = (dialCode) => {
  selectedCountry.value = dialCode;
  isDropdownOpen.value = false;
};

const filteredCountries = computed(() => {
  return [...countryCodes.value].sort((a, b) => a.name.localeCompare(b.name));
});

// Cargar códigos de país desde la API
const loadCountryCodes = async () => {
  const token = session.value ? session.value.token_api : null;

  if (!token) {
    error.value = "No se encontró la sesión del usuario. Vuelve a iniciar sesión.";
    return;
  }

  const url = `${process.env.VUE_APP_API_BASE_URL}/get-country-preferences`;
  const options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token.trim()}`,
    },
  };

  try {
    const response = await axios.get(url, options);
    countryCodes.value = response.data;
    console.log("Códigos de país activos cargados:", countryCodes.value);

    // Si no hay código de país seleccionado ya (desde getProfile)
    if (countryCodes.value.length > 0 && !selectedCountry.value) {
      // Primero intentar con +52 (México) como predeterminado
      const mexicoCountry = countryCodes.value.find(c => c.dial_code === '+52');
      
      if (mexicoCountry) {
        selectedCountry.value = '+52';
      } else {
        // Si no está México, usar el primer país de la lista
        selectedCountry.value = countryCodes.value[0].dial_code;
      }
    }
  } catch (err) {
    console.error("Error al cargar códigos de país:", err);
    error.value = "No se pudieron cargar los códigos de país.";
  }
};
// Guardar los datos del usuario y luego enviar OTP
const saveUserData = async () => {
  if (!validateForm()) {
    isSubmitting.value = false;
    return;
  }

  const token = session.value.token_api;
  const userId = session.value.id;

  error.value = "";
  validationErrors.value = {};

  const userData = {
    name: userName.value,
    last_name: lastName.value,
    last_second_name: motherLastName.value,
    phone: phoneNumber.value,
    country_code: selectedCountry.value,
    rol: defaultRolId.value,
  };

  const url = `${process.env.VUE_APP_API_BASE_URL}/profile/create_new_advisor/${userId}`;
  const options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token.trim()}`,
    },
  };

  try {
    const response = await axios.post(url, userData, options);

    if (response.status === 200) {
      store.commit('setUserData', {
        name: userName.value,
        lastName: lastName.value,
        motherLastName: motherLastName.value,
        phone: phoneNumber.value
      });
      toastAlert.value = true;
      typeMsg.value = 'success';
      msg.value = 'Datos guardados correctamente';
      tittle.value = 'Exito'
      setTimeout(() => {
        closeToast();
        router.push({ name: 'step2' });
      }, 2000);
      console.log("Datos guardados con éxito");
    }

  } catch (err) {
    isSubmitting.value = false;
    console.error("Error al guardar datos del usuario:", err);

    if (err.response?.status === 422) {
      validationErrors.value = err.response.data.errors;
    } else if (err.response?.status === 409) {
      error.value = err.response.data.message || "El número de teléfono ya está registrado.";
    } else {
      toastAlert.value = true;
      typeMsg.value = 'success';
      msg.value = err.response?.data?.message || "Error al guardar los datos. Inténtalo nuevamente.";
      tittle.value = 'Error'
      setTimeout(() => closeToast(), 5000);
    }
  }
};
const checkPhoneExists = async () => {
  if (!validateForm()) {
    isSubmitting.value = false;
    return { exists: false, error: true };
  }

  const token = session.value.token_api;
  const completePhone = phoneNumber.value;
  const countryCode = selectedCountry.value;  // Asumo que `selectedCountry.value` contiene el código del país
  console.log(countryCode);
  try {
    const response = await axios.get(
      `${process.env.VUE_APP_API_BASE_URL}/broker/check-phone-exists`,
      {
        params: {
          phone: completePhone,
          country_code: countryCode,  // Aquí pasas el código del país
          user_id: session.value.id // Opcional: para excluir al usuario actual
        },
        headers: {
          Authorization: `Bearer ${token.trim()}`,
        },
      }
    );
    
    return { exists: response.data.exists, error: false, message: response.data.message };
  } catch (err) {
    console.error("Error al verificar el teléfono:", err);
    error.value = err.response?.data?.message || "El teléfono ya está registrado.";
    return { exists: false, error: true, message: error.value };
  }
};

// Enviar OTP con código de país seleccionado
const sendOTP = async () => {
  if (!session.value || !session.value.token_api || !session.value.id) {
    error.value = "No se encontró la sesión del usuario. Vuelve a iniciar sesión.";
    return;
  }

  if (!validateForm()) {
    return;
  }

  isSubmitting.value = true;

  try {
    // 1. Primero verificamos si el teléfono ya existe
    const { exists, error: checkError, message } = await checkPhoneExists();
    
    if (checkError) {
      isSubmitting.value = false;
      return;
    }
    
    if (exists) {
      isSubmitting.value = false;
      error.value = message || "El número de teléfono ya está registrado. Por favor, utiliza otro número.";
      //toastAlert.value = true;
      typeMsg.value = 'error';
      msg.value = error.value;
      setTimeout(() => closeToast(), 5000);
      return;
    }
    
    // 2. Si el teléfono no existe, procedemos a enviar el OTP
    const token = session.value.token_api;
    const userId = session.value.id;

    const url = `${process.env.VUE_APP_API_BASE_URL}/send-otp`;
    const options = {
      headers: {
        Authorization: `Bearer ${token.trim()}`,
      },
    };

    const response = await axios.post(
      url,
      {
        user_id: userId,
        phone_number: selectedCountry.value + phoneNumber.value,
      },
      options
    );

    if (response.status === 200) {
      console.log("OTP enviado con éxito");

      toastAlert.value = true;
      typeMsg.value = 'success';
      msg.value = 'Código de verificación enviado con éxito';
      tittle.value = 'Exito'
      
      // 3. Luego de enviar OTP, guarda los datos
      await saveUserData();
    }

  } catch (err) {
    console.error("Error al enviar código OTP:", err);
    error.value = err.response?.data?.detail || "Error al enviar el código de verificación.";
    toastAlert.value = true;
    typeMsg.value = 'error';
    msg.value = error.value;
  } finally {
    isSubmitting.value = false;
    setTimeout(() => closeToast(), 5000);
  }
};

  async function closeToast() {
    toastAlert.value = false;
    typeMsg.value = "";
    msg.value = "";
    tittle.value = "";
  }
</script>

<style scoped>
.custom-select-container {
  position: relative;
  width: 100%;
  user-select: none;
}

.selected-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: white;
  cursor: pointer;
}

.country-item, .country-option {
  display: flex;
  align-items: center;
  gap: 8px;
}

.placeholder {
  color: #666;
}

.arrow-down {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #666;
  margin-left: 8px;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 200px;
  overflow-y: auto;
  background-color: white;
  border: 1px solid #ccc;
  border-top: none;
  border-radius: 0 0 8px 8px;
  z-index: 100;
}

.country-option {
  padding: 8px 12px;
  cursor: pointer;
}

.country-option:hover {
  background-color: #f5f5f5;
}

.flag-img {
  width: 24px;
  height: auto;
  vertical-align: middle;
  border: 1px solid #ddd;
}

.error-message {
  color: red;
}
</style>